import * as React from 'react';
import './Logo.css';
import { Container } from 'reactstrap';

export class Logo extends React.Component<any, {}> {
  render() {
    return (
      <Container className="hero">
        <div className="logo-container">
          <img className="logo wow fadeIn" src="/assets/images/logo-large-white.png" />
          <div className="logo-subtitle wow fadeIn" data-wow-delay="0.1s">Hyvien kokemusten muotoilutoimisto</div>
        </div>
      </Container>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/logo/Logo.tsx